import { createFileRoute } from '@tanstack/react-router';
import { CreateQuoteWizard } from '@/features/client/quotes/create-quote';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client/quotes/new')({
  beforeLoad: clientGuard,
  component: CreateQuoteRoute,
});

function CreateQuoteRoute() {
  return <CreateQuoteWizard />;
}
